// Mock data for MM Renovations LTD website

export const mockData = {
  company: {
    name: "MM Renovations LTD",
    phone: "613-295-9098",
    email: "MM.renos89@gmail.com",
    tagline: "Transform Your Space, Elevate Your Life",
    description: "Specializing in full home renovations and SDU creations, we bring your vision to life with expert craftsmanship and attention to detail."
  },

  services: [
    {
      id: 1,
      title: "Full Home Renovations",
      description: "Complete home transformations from concept to completion. Kitchen remodels, bathroom upgrades, basement finishing, and whole-home makeovers.",
      features: ["Custom Design", "Quality Materials", "Licensed Contractors", "Project Management"]
    },
    {
      id: 2,
      title: "SDU Creation",
      description: "Maximize your property value with Secondary Dwelling Units. Perfect for generating rental income or creating flexible living space.",
      features: ["Permit Assistance", "Income Potential", "Increase Property Value", "Turnkey Solutions"]
    },
    {
      id: 3,
      title: "Kitchen Remodeling",
      description: "Create the kitchen of your dreams with modern designs, premium finishes, and functional layouts that enhance your cooking experience.",
      features: ["Custom Cabinetry", "Modern Appliances", "Stone Countertops", "Smart Storage"]
    },
    {
      id: 4,
      title: "Bathroom Renovations",
      description: "Luxury bathroom upgrades that combine style and functionality. From spa-like retreats to practical family bathrooms.",
      features: ["Walk-in Showers", "Modern Fixtures", "Heated Floors", "Custom Vanities"]
    }
  ],

  projects: [
    {
      id: 1,
      title: "Ainsley SDU",
      category: "SDU Creation",
      location: "Ottawa, ON",
      duration: "10 weeks",
      images: [
        "https://customer-assets.emergentagent.com/job_home-transformers-2/artifacts/ulqhu1gb_IMG_0006.JPG",
        "https://customer-assets.emergentagent.com/job_home-transformers-2/artifacts/d9wcvene_IMG_0001.JPG",
        "https://customer-assets.emergentagent.com/job_home-transformers-2/artifacts/kc9w364l_IMG_0005.JPG",
        "https://customer-assets.emergentagent.com/job_home-transformers-2/artifacts/fhk01lah_IMG_0009.JPG",
        "https://customer-assets.emergentagent.com/job_home-transformers-2/artifacts/1ayka41d_IMG_0007.JPG"
      ],
      image: "https://customer-assets.emergentagent.com/job_home-transformers-2/artifacts/d9wcvene_IMG_0001.JPG"
    },
    {
      id: 2,
      title: "Hexham SDU",
      category: "SDU Creation",
      location: "Ottawa, ON",
      duration: "12 weeks",
      images: [
        "https://customer-assets.emergentagent.com/job_home-transformers-2/artifacts/mj27wm4k_IMG_0008%20Medium.jpeg",
        "https://customer-assets.emergentagent.com/job_home-transformers-2/artifacts/ckarlm8i_IMG_0011%20Medium.jpeg",
        "https://customer-assets.emergentagent.com/job_home-transformers-2/artifacts/15yljji0_IMG_0016%20Medium.jpeg",
        "https://customer-assets.emergentagent.com/job_home-transformers-2/artifacts/d117p3vz_IMG_0020%20Medium.jpeg",
        "https://customer-assets.emergentagent.com/job_home-transformers-2/artifacts/a6lmuk9p_IMG_0021%20Medium.jpeg",
        "https://customer-assets.emergentagent.com/job_home-transformers-2/artifacts/04xb5jdq_IMG_0024%20Medium.jpeg",
        "https://customer-assets.emergentagent.com/job_home-transformers-2/artifacts/5copis5n_IMG_0033%20Medium.jpeg",
        "https://customer-assets.emergentagent.com/job_home-transformers-2/artifacts/vtboq1f4_IMG_0060%20Medium.jpeg",
        "https://customer-assets.emergentagent.com/job_home-transformers-2/artifacts/y5n05096_IMG_0065%20Medium.jpeg"
      ],
      image: "https://customer-assets.emergentagent.com/job_home-transformers-2/artifacts/mj27wm4k_IMG_0008%20Medium.jpeg"
    },
    {
      id: 3,
      title: "Modern Bathroom Update",
      category: "Bathroom Renovation",
      location: "Ottawa, ON",
      duration: "3 weeks",
      images: [
        "https://customer-assets.emergentagent.com/job_home-transformers-2/artifacts/0nqcjuvx_IMG_8594.JPG",
        "https://customer-assets.emergentagent.com/job_home-transformers-2/artifacts/l9w1tu80_DSC04952.JPG"
      ],
      image: "https://customer-assets.emergentagent.com/job_home-transformers-2/artifacts/0nqcjuvx_IMG_8594.JPG"
    },
    {
      id: 4,
      title: "Rosebella SDU",
      category: "SDU Creation",
      location: "Ottawa, ON",
      duration: "11 weeks",
      images: [
        "https://customer-assets.emergentagent.com/job_home-transformers-2/artifacts/bg98l95q_IMG_8338.jpeg",
        "https://customer-assets.emergentagent.com/job_home-transformers-2/artifacts/nrlh30l1_IMG_8339.jpeg",
        "https://customer-assets.emergentagent.com/job_home-transformers-2/artifacts/3igepk9b_IMG_8340.jpeg",
        "https://customer-assets.emergentagent.com/job_home-transformers-2/artifacts/b5zxxsz4_IMG_8342.jpeg",
        "https://customer-assets.emergentagent.com/job_home-transformers-2/artifacts/44zkf6mp_IMG_8343.jpeg"
      ],
      image: "https://customer-assets.emergentagent.com/job_home-transformers-2/artifacts/bg98l95q_IMG_8338.jpeg"
    },
    {
      id: 5,
      title: "Nepean SDU",
      category: "SDU Creation",
      location: "Nepean, ON",
      duration: "14 weeks",
      images: [
        "https://customer-assets.emergentagent.com/job_home-transformers-2/artifacts/vke8elwx_IMG_0812.jpeg",
        "https://customer-assets.emergentagent.com/job_home-transformers-2/artifacts/nca0kzzt_IMG_0813.jpeg",
        "https://customer-assets.emergentagent.com/job_home-transformers-2/artifacts/d6nuperl_69223758660__874D0E95-8265-4ECA-9C66-1CB1C7AEAE4B.jpeg",
        "https://customer-assets.emergentagent.com/job_home-transformers-2/artifacts/9xpl1rbw_69223757160__E09E43CE-28D1-4FD1-8694-02989D9149E5.jpeg"
      ],
      image: "https://customer-assets.emergentagent.com/job_home-transformers-2/artifacts/vke8elwx_IMG_0812.jpeg"
    },
    {
      id: 6,
      title: "Basement Renovation",
      category: "Basement Finishing",
      location: "Ottawa, ON",
      duration: "9 weeks",
      images: [
        "https://customer-assets.emergentagent.com/job_home-transformers-2/artifacts/tsi5wolk_IMG_2253.jpeg",
        "https://customer-assets.emergentagent.com/job_home-transformers-2/artifacts/amo3rrvj_IMG_2255.jpeg",
        "https://customer-assets.emergentagent.com/job_home-transformers-2/artifacts/awrbe9qy_IMG_2257.jpeg",
        "https://customer-assets.emergentagent.com/job_home-transformers-2/artifacts/1b0xcbgw_IMG_2258.jpeg",
        "https://customer-assets.emergentagent.com/job_home-transformers-2/artifacts/3cke23kf_IMG_2259.jpeg"
      ],
      image: "https://customer-assets.emergentagent.com/job_home-transformers-2/artifacts/tsi5wolk_IMG_2253.jpeg"
    }
  ],

  process: [
    {
      step: 1,
      title: "Initial Consultation",
      description: "We meet with you to understand your vision, needs, and budget. Free in-home consultation included.",
      duration: "1-2 hours"
    },
    {
      step: 2,
      title: "Design & Planning",
      description: "Our team creates detailed plans and 3D renderings. We handle all permits and approvals.",
      duration: "2-3 weeks"
    },
    {
      step: 3,
      title: "Material Selection",
      description: "Choose from premium materials and finishes. We guide you through every selection.",
      duration: "1 week"
    },
    {
      step: 4,
      title: "Construction",
      description: "Expert craftsmen bring your project to life. Regular updates and quality inspections.",
      duration: "Varies by project"
    },
    {
      step: 5,
      title: "Final Walkthrough",
      description: "We ensure every detail meets your expectations. Your satisfaction is our priority.",
      duration: "1 day"
    }
  ],

  testimonials: [
    {
      id: 1,
      name: "Sarah Johnson",
      role: "Homeowner",
      content: "MM Renovations transformed our outdated kitchen into a modern masterpiece. The team was professional, on time, and the quality exceeded our expectations!",
      rating: 5,
      project: "Kitchen Renovation"
    },
    {
      id: 2,
      name: "Michael Chen",
      role: "Property Investor",
      content: "The SDU they built on my property has been generating excellent rental income. The ROI has been fantastic. Highly recommend for investors!",
      rating: 5,
      project: "SDU Creation"
    },
    {
      id: 3,
      name: "Emily Roberts",
      role: "Homeowner",
      content: "From start to finish, the process was seamless. They handled all permits and kept us informed every step of the way. Our bathroom is stunning!",
      rating: 5,
      project: "Bathroom Renovation"
    },
    {
      id: 4,
      name: "David Martinez",
      role: "Homeowner",
      content: "We renovated our entire home with MM Renovations. The attention to detail and craftsmanship is exceptional. Worth every penny!",
      rating: 5,
      project: "Full Home Renovation"
    }
  ],

  videoTestimonials: [
    {
      id: 1,
      name: "Jennifer & Mark Thompson",
      role: "Homeowners - Barrhaven",
      project: "Full Home Renovation",
      thumbnail: "https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=800",
      videoUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ",
      duration: "2:15",
      quote: "Our dream home became a reality"
    },
    {
      id: 2,
      name: "Robert Singh",
      role: "Property Investor",
      project: "SDU Creation - Income Property",
      thumbnail: "https://images.unsplash.com/photo-1600585154526-990dced4db0d?w=800",
      videoUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ",
      duration: "3:30",
      quote: "Generating $2,500/month in rental income"
    },
    {
      id: 3,
      name: "Amanda Wilson",
      role: "Homeowner - Kanata",
      project: "Kitchen & Bathroom Remodel",
      thumbnail: "https://images.unsplash.com/photo-1556911220-bff31c812dba?w=800",
      videoUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ",
      duration: "1:45",
      quote: "Professional, on-time, and stunning results"
    }
  ],

  faqs: [
    {
      id: 1,
      question: "How long does a typical renovation take?",
      answer: "Timeline varies by project scope. Kitchen renovations typically take 4-8 weeks, bathrooms 3-5 weeks, and SDU creations 10-16 weeks. We provide detailed timelines during consultation."
    },
    {
      id: 2,
      question: "Do you handle permits and approvals?",
      answer: "Yes! We manage all permits, inspections, and approvals required for your project. Our team has extensive experience navigating local building codes and regulations."
    },
    {
      id: 3,
      question: "What is the cost range for renovations?",
      answer: "Costs vary based on project size, materials, and complexity. Kitchen renovations typically start at $25,000, bathrooms at $15,000, and SDUs at $80,000. Use our cost estimator for a quick estimate."
    },
    {
      id: 4,
      question: "Do you offer financing options?",
      answer: "Yes, we work with several financing partners to help make your renovation dreams affordable. We can discuss options during your consultation."
    },
    {
      id: 5,
      question: "What makes SDUs a good investment?",
      answer: "SDUs generate rental income, increase property value by 20-30%, and provide flexible living space for family or guests. They're perfect for investors and homeowners alike."
    },
    {
      id: 6,
      question: "Are you licensed and insured?",
      answer: "Absolutely. MM Renovations LTD is fully licensed, bonded, and insured. All our contractors are certified professionals with years of experience."
    },
    {
      id: 7,
      question: "Can I stay in my home during renovation? What about furniture storage?",
      answer: "It depends on the scope of the renovation. For kitchen and bathroom projects, many clients remain in the home. For whole-home renovations, moving furniture into storage or temporarily relocating can significantly reduce disruption. Using experienced Ottawa moving companies can help protect your belongings during the renovation process. We recommend booking Ottawa moving companies to handle furniture and storage professionally.",
      link: {
        text: "Visit Wise Move for trusted moving services",
        url: "https://www.wisemove.ca/moving-companies/ottawa"
      }
    },
    {
      id: 8,
      question: "What areas do you serve?",
      answer: "We serve Ottawa and surrounding areas including Nepean, Kanata, Barrhaven, Orleans, Gloucester, and more. Contact us to confirm service in your area."
    }
  ],

  team: [
    {
      id: 1,
      name: "Marco M.",
      role: "Founder & Lead Contractor",
      bio: "20+ years of construction experience with a passion for transforming spaces."
    },
    {
      id: 2,
      name: "Maria M.",
      role: "Project Manager",
      bio: "Expert in coordinating projects from concept to completion with meticulous attention to detail."
    },
    {
      id: 3,
      name: "Construction Team",
      role: "Licensed Professionals",
      bio: "Our skilled craftsmen bring expertise in carpentry, plumbing, electrical, and finishing work."
    }
  ],

  ebook: {
    title: "Complete Guide to Home Renovations",
    description: "Download our comprehensive e-book and discover insider tips, cost-saving strategies, and essential planning advice for your renovation project.",
    chapters: [
      "Planning Your Renovation Budget",
      "Choosing the Right Contractor",
      "Permits & Regulations Guide",
      "Material Selection Tips",
      "Maximizing ROI on Renovations",
      "SDU Investment Opportunities"
    ]
  },

  about: {
    mainTitle: "Building Dreams, Creating Value",
    subtitle: "Your Trusted Partner in Home Renovations & SDU Development",
    story: "Founded with a passion for transforming spaces and creating lasting value, MM Renovations LTD has become Ottawa's premier choice for comprehensive home renovations and Secondary Dwelling Unit (SDU) creation. Our journey began with a simple belief: every homeowner deserves quality craftsmanship, transparent communication, and projects completed on time and on budget.",
    mission: "To deliver exceptional renovation experiences that transform houses into dream homes and properties into profitable investments.",
    stats: [
      {
        number: "200+",
        label: "Projects Completed",
        icon: "check"
      },
      {
        number: "15+",
        label: "Years Experience",
        icon: "award"
      },
      {
        number: "98%",
        label: "Client Satisfaction",
        icon: "star"
      },
      {
        number: "$50M+",
        label: "Property Value Added",
        icon: "dollar"
      }
    ],
    values: [
      {
        title: "Quality Craftsmanship",
        description: "We never compromise on quality. Every project receives the same meticulous attention to detail, using premium materials and expert techniques.",
        icon: "hammer"
      },
      {
        title: "Transparent Communication",
        description: "From initial consultation to final walkthrough, we keep you informed every step of the way. No surprises, just clear, honest updates.",
        icon: "message"
      },
      {
        title: "On-Time Delivery",
        description: "We respect your time and investment. Our detailed project management ensures completion within agreed timelines.",
        icon: "clock"
      },
      {
        title: "Licensed & Insured",
        description: "Full licensing, bonding, and insurance give you peace of mind. We handle all permits and comply with local building codes.",
        icon: "shield"
      }
    ],
    whyChooseUs: [
      "Comprehensive service from design to completion",
      "Experienced team of certified contractors",
      "Specialization in both residential renovations and SDU development",
      "Proven track record of excellence",
      "Free in-home consultations and detailed quotes",
      "Warranty on all workmanship"
    ]
  }
};
